import React, { Component, Children } from "react";
import styled from "styled-components";

class DetailsCard extends Component {
  constructor() {
    super();
  }
  render() {
    const OneDetailsCard = styled.div`
      text-align: left;
      border-radius: 4px;

      color: #000;
      font-family: Lato;
      font-size: 16px;
      letter-spacing: -0.01px;
      line-height: 19px;
      min-height: 288px;
      border-radius: 6px 6px 0 0;
      background-color: #fff;
      border: 1px solid #f6f6f6;
    `;

    const OneDetailsCardHead = styled.div`
      border-radius: 6px 6px 0 0;
      background-color: #e1e1e1;
      border: 1px solid #f6f6f6;
      text-align: left;
      padding: 1.5%;

      color: #000;
      font-family: Lato;
      font-size: 18px;
      letter-spacing: -0.01px;
      line-height: 19px;
      min-height: 63px;
      align-items: center;
      display: flex;
      text {
        padding-left: 29px;
      }
    `;
    const OneDetailsCardDetails = styled.div`
      text-align: left;
      padding: 28px 28px 28px 55px;

      color: #000;
      font-family: Lato;
      font-size: 16px;
      letter-spacing: -0.01px;
      line-height: 26px;
      min-height: 225px;
      ul > li {
        list-style-type: disc;
        padding-bottom: 15px;
      }
    `;
    return (
      <OneDetailsCard>
        <OneDetailsCardHead>
          <text>{this.props.detailtitle}</text>
        </OneDetailsCardHead>
        <OneDetailsCardDetails>{this.props.children}</OneDetailsCardDetails>
      </OneDetailsCard>
    );
  }
}

export default DetailsCard;
